export interface GalleryPhoto {
  image?: string | null;
  alt_text?: string | null;
  title?: string | null;
  description?: string | null;
  source_page_urls?: string | null;
  original_url?: string | null;
}

function getUrlPath(url: string | null | undefined): string {
  if (!url) return '';

  try {
    return decodeURIComponent(new URL(url).pathname);
  } catch {
    return '';
  }
}

function photoText(photo: GalleryPhoto): string {
  const parts = [
    photo.title,
    photo.description,
    photo.alt_text,
    getUrlPath(photo.image),
    getUrlPath(photo.original_url),
    photo.source_page_urls,
  ];

  return parts
    .filter((part): part is string => Boolean(part))
    .join(' ')
    .toLowerCase();
}

function scorePhoto(text: string, keywords: string[]): number {
  return keywords.reduce(
    (score, keyword) => score + (text.includes(keyword) ? 1 : 0),
    0,
  );
}

function presetSlot(preset: string): number {
  let hash = 0;

  for (let index = 0; index < preset.length; index += 1) {
    hash = ((hash << 5) - hash + preset.charCodeAt(index)) | 0;
  }

  return Math.abs(hash);
}

export function pickHeroImage(
  gallery: GalleryPhoto[],
  keywords: string[],
  preset: string,
): number {
  if (!gallery.length) return -1;

  let bestIndex = -1;
  let bestScore = 0;

  for (let index = 0; index < gallery.length; index += 1) {
    const score = scorePhoto(photoText(gallery[index]), keywords);
    if (score <= bestScore) continue;

    bestScore = score;
    bestIndex = index;
  }

  if (bestIndex >= 0) return bestIndex;

  return presetSlot(preset) % gallery.length;
}
